import omit from 'lodash/omit.js'

import type {
  TooltipLayerState,
  TooltipContent,
  TooltipOptions,
  TooltipTarget,
} from 'store'

export const useTooltipLayerStore = defineStore('tooltip-layer.store', {
  state: (): TooltipLayerState => ({
    tooltipMap: {},
    target: 'tooltip-layer-default',
  }),

  actions: {
    createTooltip(
      content: TooltipContent,
      el: TooltipTarget,
      options?: TooltipOptions,
    ) {
      if (!process.client) return
      const key = Math.random().toString()
      const defaultOptions: TooltipOptions = {
        position: 'top',
      }

      this.tooltipMap = {
        ...this.tooltipMap,
        [key]: [content, el, { ...defaultOptions, ...options }],
      }

      el.addEventListener('mouseleave', () => this.removeTooltip(key), {
        once: true,
      })
    },
    removeTooltip(key: string) {
      this.tooltipMap = omit(this.tooltipMap, key)
    },
  },
})
